module.exports = __webpack_public_path__ + "img/Joker.487a8fbf.jpg";